import d from "./node_modules/react-slider/dist/es/dev/index.mjs";export default d;